module.exports = __webpack_public_path__ + "assets/img/Pad landscape 1-min.ae494aba.png";